var FocusOnService = /** @class */ (function () {
    function FocusOnService($timeout, $rootScope) {
        'ngInject';
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
    }
    FocusOnService.prototype.focus = function (name) {
        var _this = this;
        this.$timeout(function () {
            _this.$rootScope.$broadcast('focusOn', name);
        });
    };
    return FocusOnService;
}());
export { FocusOnService };
//# sourceMappingURL=focus-on.service.js.map